module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-tomcat-01.d78e81dc1360f28c29a21236a320626a.png";